import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import { UploadCloud, Loader2 } from 'lucide-react';
import { API } from '../api';

export default function FileDrop({ accept = '*/*', multiple = false, onUploaded, label, className = '', testId = 'file-drop', children }) {
  const ref = useRef(null);
  const [progress, setProgress] = useState(null);

  const handle = async (list) => {
    const files = Array.from(list || []).slice(0, multiple ? 8 : 1);
    if (!files.length) return;
    try {
      for (const f of files) {
        setProgress(0);
        const res = await API.upload(f, setProgress);
        onUploaded(res, f);
      }
    } catch (e) { toast.error(e?.response?.data?.detail || 'Upload failed. Try again.'); }
    finally { setProgress(null); if (ref.current) ref.current.value = ''; }
  };

  return (
    <div className={className}>
      <button type="button" data-testid={testId} disabled={progress !== null}
        onClick={() => ref.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); handle(e.dataTransfer.files); }}
        className="w-full rounded-2xl border border-dashed border-gold/25 bg-panel2/40 p-5 flex items-center gap-3 text-sm text-cream/55 hover:border-gold/50 transition-colors disabled:opacity-70 text-left">
        {progress !== null ? <Loader2 size={18} className="text-gold animate-spin shrink-0" /> : <UploadCloud size={18} className="text-gold/70 shrink-0" />}
        <span className="flex-1">{progress !== null ? `Uploading\u2026 ${progress}%` : (children || label)}</span>
      </button>
      <input ref={ref} type="file" accept={accept} multiple={multiple} className="hidden" onChange={(e) => handle(e.target.files)} />
    </div>
  );
}
